import { useEffect } from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import ROUTE from '../../constants/route';
import {logger, updateHistory} from '../../helpers/grid-history';

const GridHistory = props => {
  const {
    grid,
    initialParams,
    matchParams = null,
    history,
    history: {
      action,
      location: { pathname, state },
    },
    children,
  } = props;

  useEffect(() => {
    if (grid.data.init) {
      const params = getInitialParams();
      grid.actions.fetch(params);
      logger(`FETCH (PATH CHANGED)`, pathname, params, state);
    }
  }, [pathname]);

  useEffect(() => {
    if (!state || !state.gridParams) {
      const gridInitialParams = getInitialParams();
      const params =
        state && state.initialParams
          ? { ...gridInitialParams, ...state.initialParams }
          : gridInitialParams;
      grid.actions.fetch(params).catch(catchError);
      logger(`FETCH (${action})`, pathname, params, state);
    } else if (action === 'POP' && state.gridParams) {
      grid.actions.fetch(state.gridParams).catch(catchError);
      logger(`FETCH (${action})`, pathname, state.gridParams, state);
    }
  }, [state]);

  useEffect(() => {
    if (
      grid.data.pagesCount &&
      grid.data.pagesCount === grid.data.page &&
      !grid.data.rows.length
    ) {
      const nextParams = cloneDeep({
        ...grid.data.params,
        page: grid.data.params.page - 1,
      });
      if (nextParams.page === 0) {
        delete nextParams.page;
      }
      grid.actions
        .fetch(nextParams)
        .then(params => updateHistory(history, params, true));

      logger(`FETCH (PAGE COUNT)`, pathname, nextParams, state);
    }
  }, [grid.data.pagesCount]);

  const getInitialParams = () => {
    let gridInitialParams = { ...initialParams };

    if (matchParams) {
      gridInitialParams = { ...matchParams, ...gridInitialParams };
    }

    if (state && state.initialParams) {
      gridInitialParams = {
        ...gridInitialParams,
        ...state.initialParams,
      };
    }

    return gridInitialParams;
  };

  const catchError = response => {
    if ((response && response.code === 404) || response.code === 403) {
      history.replace(ROUTE.ERROR_404);
    }
  };

  return children || null;
};

GridHistory.propTypes = {
  grid: PropTypes.shape({
    data: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  }).isRequired,
  initialParams: PropTypes.object,
  matchParams: PropTypes.object,
  history: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default GridHistory;
